// src/hooks/useArchivos.js
import { useState, useCallback } from "react";
import Swal from "sweetalert2";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

export default function useArchivos(ruta = "") {
  const [archivos, setArchivos] = useState([]);
  const [cargando, setCargando] = useState(false);

  const initArchivos = useCallback((lista = []) => {
    setArchivos(lista);
  }, []);

  const subirArchivosYObtenerURLs = async (nuevos) => {
    const storage = getStorage();
    const resultados = [];
    for (const file of nuevos) {
      // ¡Aquí es donde usamos la ruta dinámica!
      const archivoRef = ref(storage, `${ruta}/${file.name}`);
      await uploadBytes(archivoRef, file);
      const url = await getDownloadURL(archivoRef);
      resultados.push({ nombre: file.name, url });
    }
    return resultados;
  };

  const manejarArchivos = async (e) => {
    const seleccion = Array.from(e.target.files);
    const sinDupli = seleccion.filter(
      (f) => !archivos.some((a) => a.nombre === f.name)
    );
    if (!sinDupli.length) {
      return Swal.fire({ icon: "info", title: "Archivos duplicados" });
    }
    if (archivos.length + sinDupli.length > 10) {
      return Swal.fire({ icon: "error", title: "Límite: 10 archivos" });
    }

    setCargando(true);
    try {
      const nuevos = await subirArchivosYObtenerURLs(sinDupli);
      setArchivos((prev) => [...prev, ...nuevos]);
    } catch (error) {
      console.error(error);
      Swal.fire({ icon: "error", title: "Error al cargar archivos" });
    } finally {
      setCargando(false);
    }
  };

  const eliminarArchivo = (nombre) => {
    Swal.fire({
      title: "¿Eliminar archivo?",
      icon: "warning",
      showCancelButton: true,
    }).then((res) => {
      if (res.isConfirmed) {
        setArchivos((prev) => prev.filter((a) => a.nombre !== nombre));
        Swal.fire("Eliminado", "El archivo fue eliminado.", "success");
      }
    });
  };

  const descargarArchivo = (url, nombre) => {
    const a = document.createElement("a");
    a.href = url;
    a.download = nombre;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const obtenerIcono = (ext) => {
    if (["xls", "xlsx", "csv"].includes(ext))
      return { icon: "bi-file-earmark-excel", color: "green" };
    if (["doc", "docx"].includes(ext))
      return { icon: "bi-file-earmark-word", color: "blue" };
    if (ext === "pdf") return { icon: "bi-file-earmark-pdf", color: "red" };
    if (["jpg", "jpeg", "png", "svg"].includes(ext))
      return { icon: "bi-image", color: "blue" };
    return { icon: "bi-file-earmark", color: "gray" };
  };

  return {
    archivos,
    cargando,
    initArchivos,
    manejarArchivos,
    eliminarArchivo,
    descargarArchivo,
    obtenerIcono,
  };
}
